<template>
    <Password />
</template>

<script>
import Password from '@/components/Password.vue';

export default {
    components: {
        Password
    }
};
</script>

<style lang="sass">
/* CSSファイルの読み込み */
@use '../../../sass/auth/password-new/common.scss' as *
</style>
